module.exports = __webpack_public_path__ + "img/logo-mobile.984476bb.png";